import { render, staticRenderFns } from "./FrontPage.vue?vue&type=template&id=6dc2d49b"
import script from "./FrontPage.vue?vue&type=script&lang=ts"
export * from "./FrontPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports